import { inject, Injectable, signal } from "@angular/core";
import { ApiService } from "./api.service";
import { LoadingService } from "./loading.service";
import {environment} from '../../../environments/environment';
import { catchError, EMPTY, Observable, of, tap } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class WsService {
    apiService = inject(ApiService);
    loadingService = inject(LoadingService);

    private ws: WebSocket | null = null;
    public isConnected = signal<boolean>(false);
    public messageQueue = signal<any[]>([]);

    GetWebSocketSessionOTP()  {
        return this.apiService.SendPost(`/auth/otp`, this.loadingService.StatesNames.CHATS_WS_CONNECT);
    }

    GetWebSocketSessionOTPTest()  {
        return of({ value: 'c7df9c87-9f56-4910-9075-770319babdfc' })
    }

    Connect() {
        if (this.ws) this.Disconnect();

        this.GetWebSocketSessionOTP().pipe(
            tap((res: {otpCode: string}) => {
                this.ws = new WebSocket(`${environment.webSocket}?otp=${res.otpCode}`);
                this.ws.onmessage = (event) => {
                    try {
                        let pd = JSON.parse(event.data)
                        this.messageQueue.update(queue => [...queue, pd]);
                    } catch (error) {
                         console.warn(`❌ cant parse json`)
                    }
                };
                this.ws.onopen = () => {
                    //console.log(`WebSocket connected ${new Date()}`);
                    this.isConnected.set(true)
                };
                this.ws.onclose = () => {
                    //console.log(`WebSocket disconnected ${new Date()}`);
                    this.isConnected.set(false)
                    setTimeout(() => {
                         this.Connect();
                    }, 5 * 1000);
                };
                this.ws.onerror = (err) => {
                    console.error('WebSocket error:', err);
                    this.isConnected.set(false);
                }
            }),
            catchError(() => {
                console.warn(`❌ Ошибка получения OTP для WS`)
                this.Disconnect();
                return EMPTY;
            })
        ).subscribe()
    }

    SendMessage(message: any) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(message);
        } else {
            console.warn('❌ WebSocket не открыт. Статус:', this.ws?.readyState);
        }
    }

    Disconnect() {
        if (this.ws) {
            //console.log("Disconnect!")
            this.ws.close();
            this.ws = null;
            this.isConnected.set(false)
        }
    }
}
